// extracted by mini-css-extract-plugin
export var actionButton = "_i8-0";
export var fileInput = "_i8-2";
export var paperclip = "_i8-1";